import { render, staticRenderFns } from "./GiftCardAddDialog.vue?vue&type=template&id=33e8d074&"
import script from "./GiftCardAddDialog.vue?vue&type=script&lang=ts&"
export * from "./GiftCardAddDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports